export const authRoutes = [
  {
    key: 10,
    path: "login",
    component: 'Login',

  },
  {
    key: 11,
    path: "forget-password",
    component: 'ForgetPassword'
  },
  {
    key: 12,
    path: "reset-password/:token",
    component: 'ResetPassword'
  }
]

export const appRoutes = [
  {
    key: 2,
    path: "welcome",
    component: 'Welcome'
  },
  {
    key: 3,
    path: "dashboard",
    component: 'Dashboard'
  },
  {
    key: 4,
    path: "repositories",
    component: 'Repositories'
  },
  {
    key: 5,
    path: "data-controller",
    component: 'DataController'
  },
  {
    key: 10,
    path: "administration/users",
    component: 'Users'
  },
  {
    key: 11,
    path: "simulations/results",
    component: 'Results'
  },
  {
    key: 11,
    path: "simulations/input",
    component: 'Input'
  },
  {
    key: 12,
    path: "pricing-config",
    component: 'PricingConfiguration'
  },
  {
    key: 13,
    path: "aiguillage-tarifaire",
    component: 'AiguillageTarifaire'
  },
  {
    key: 15,
    path: "audit",
    component: 'Audit'
  },
  {
    key: 16,
    path: "json-simulator",
    component: 'JsonSimulator'
  },
  {
    key: 17,
    path: "dm-updater",
    component: 'DMUpdater'
  }
]
